import { jsx as n } from "react/jsx-runtime";
import { withManagedProps as f } from "@made-people/managed-props";
import { z as i } from "zod";
import { withZod as y } from "@made-people/react-prop-guard";
import { spacingVariants as w, themeVariants as b, positionVariants as g } from "./index-blueprint.es.js";
import { useInGrid as m } from "@made-people/blueprint-grid";
import { useInSwiper as d } from "@made-people/blueprint-swiper";
import { twMerge as u } from "tailwind-merge";
import { breakpointVisibilitySchema as k, useBreakpointVisibility as N } from "@made-people/blueprint-ui-hooks";
import { useLink as L } from "@made-people/grease-link";
import "@made-people/blueprint";
const S = i.object({
  spacing: i.custom().optional(),
  position: i.custom().optional()
}), R = i.object({
  layout: S.optional(),
  children: i.custom().optional(),
  className: i.string().optional(),
  /**
   * @deprecated Please avoid using 'background' going forward. Use 'theme' instead.
   */
  background: i.string().optional(),
  theme: i.custom().optional(),
  visibility: k.optional(),
  elementRef: i.custom().optional(),
  hasContainerQuery: i.boolean().optional(),
  wrapper: i.object({
    isEnabled: i.boolean().optional()
  }).optional(),
  id: i.string().optional(),
  wrapperLink: i.custom().optional()
}), c = (e) => {
  var t;
  const a = m(), r = d(), o = g.styles((t = e.layout) == null ? void 0 : t.position);
  return /* @__PURE__ */ n(
    "div",
    {
      ref: e.elementRef,
      className: u(o.wrapper, e.className),
      "data-in-grid": a ? "true" : "false",
      "data-in-swiper": r ? "true" : "false",
      children: e.children
    }
  );
}, v = (e) => {
  var o, t;
  const a = L();
  return (o = e.wrapperLink) != null && o.href ? /* @__PURE__ */ n(
    a,
    {
      ...e.commonProps,
      href: ((t = e.wrapperLink) == null ? void 0 : t.href) ?? "",
      ...e.wrapperLink,
      children: /* @__PURE__ */ n(
        c,
        {
          elementRef: e.elementRef,
          layout: e.layout,
          className: e.className,
          children: e.children
        }
      )
    }
  ) : /* @__PURE__ */ n("section", { ...e.commonProps, children: /* @__PURE__ */ n(
    c,
    {
      elementRef: e.elementRef,
      layout: e.layout,
      className: e.className,
      children: e.children
    }
  ) });
}, M = f(
  "ComponentWrapper",
  y(
    {
      schema: R,
      defaultProps: {
        hasContainerQuery: !0,
        wrapper: {
          isEnabled: !0
        }
      }
    },
    (e) => {
      var l, s;
      const a = w.styles((l = e.layout) == null ? void 0 : l.spacing), r = b.styles(e.theme), o = m(), t = d(), h = N({ ...e.visibility }), p = {
        className: u(
          !o && !t ? a.wrapper : void 0,
          e.background,
          r.wrapper,
          e.hasContainerQuery && "@container"
        ),
        ...h,
        id: e.id
      };
      return (s = e.wrapper) != null && s.isEnabled ? /* @__PURE__ */ n(v, { ...e, commonProps: p, children: e.children }) : /* @__PURE__ */ n("div", { className: e.className, children: e.children });
    }
  )
);
export {
  M as ComponentWrapper,
  S as componentWrapperLayoutSchema,
  R as componentWrapperSchema
};
//# sourceMappingURL=index.es.js.map
